<template>
  <div id="app">
    <ion-app class="ion-page">
      <full-width-spinner v-if="busy" />
      <v-app v-else>
        <app-header />

        <div class="content">
          <ion-vue-router class="router" />
        </div>
      </v-app>
    </ion-app>
  </div>
</template>

<script>
import { VApp } from 'vuetify/lib'
import { mapGetters } from 'vuex'

import AppHeader from './AppHeader'
import FullWidthSpinner from '../common/FullWidthSpinner'

export default {
  components: {
    AppHeader,
    VApp,
    FullWidthSpinner
  },
  data() {
    return {
      busy: true
    }
  },
  computed: {
    ...mapGetters([
      'isLoggedIn'
    ])
  },
  created() {
    this.fetchUser();
  },
  methods: {
    fetchUser() {
      if(!this.isLoggedIn) {
        this.busy = false
        return
      }

      this.$store.dispatch('fetchUser')
        .finally(() => this.busy = false)
    }
  }
};
</script>

<style>
.content {
  flex:1;
  position:static;
  overflow:auto;
}

.router {
  display:block;
  position:static;
  width:100%;
  height:100%;
}
</style>